<template lang="html">
    <div class="login-back">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-5">
               <div class="row justify-content-center">
                  <div class="col-12 col-lg-11">
                     <div class="login">
                        <div class="logo-box"></div>

                        <div class="h3">Welcome to RUBiS Energy</div>
                        <div class="text-muted t5">Welcome Back, Please Login to Continue</div>
                        
                        <div>
                           <Form 
                              classBinding="row form-box"
                              :ref="LogInModel.forms.login.name" 
                              :forms="LogInModel.forms.login.forms" 
                              :formData="LogInModel.forms.login.data"
                           />
                           <div class="link-txt link t6 bold">Forgot Password?</div>
                           
                           <div class="btns">
                              <button class="btn btn-primary" :disabled="loading" @click="logIn({ref: $refs[LogInModel.forms.login.name], router: $router})">
                                 Login <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                              </button>
                           </div>

                           <!-- <div class="options clearfix">
                              <div class="l text-muted bold">Or log in with:</div>
                              <div class="s-link google l">
                                 <i class="fab fa-google"></i>
                                 Google
                              </div>
                              <div class="s-link twitter l">
                                 <i class="fab fa-twitter"></i>
                                 Twitter
                              </div>
                              <div class="s-link facebook l">
                                 <i class="fab fa-facebook-f"></i>
                                 Facebook
                              </div>
                           </div> -->
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-12 col-md-6 col-lg-7 image-back">
               <div class="overlay"></div>
                <div class="copyright t6">&copy; RUBiS {{new Date().getFullYear()}}. All rights reserved</div>
                <!-- <div class="txt-box">
                    <div class="txt">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Possimus reiciendis vitae 
                        facere minus natus tempore repellat iusto culpa nihil aut, nulla quam cum similique 
                        asperiores autem, eum, delectus porro libero?
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import login from "./assets/stores/login.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('login')
   },
   created(){
      utils.registerModule('login',login,this.$store)
   },
   components:{
      Form: () => import("@/libs/clarks/components/form"),
   },
   computed: {
      ...mapGetters([
         'LogInModel',
         'loading',
         'showLogIn',
      ])
   },
   methods: {
      ...mapActions([
         'logIn',
      ]),
   },
   mounted(){
      utils.registerModule('login',login,this.$store)
   }
}
</script>

<style lang="scss">
@media(max-width: $breakpoint-lg){
   .login-back{
      .options{
         .text-muted{
            width: 100%;
            margin: 0 0 10px 0;
         }
         .s-link:nth-child(2){
            margin-left: 0 !important;
         }
      }
      .image-back{
         .txt-box{
            width: calc(100% - 40px) !important;
            left: 20px !important;
         }
      }
   }
}
@media(max-width: $breakpoint-md){
   .login-back{
      .image-back{
         height: auto !important;
         padding: 60px 15px;

         .txt-box{
            position: relative !important;
            top: auto !important;
            left: auto !important;
            bottom: auto !important;
            right: auto !important;
         }
      }
   }
}

.login-back {
	width: 100%;
	height: 100vh;

   .btns{
      margin: 40px 0 0 0;

      .btn-outline-primary{
         margin: 0 0 0 18px;
      }
   }
   .options{
      margin: 60px 0 20px 0;

      .s-link{
         margin: 0 15px;
         cursor: pointer;
         font-weight: $weight-bold;

         i{
            margin: 0 5px 0 0;
         }
      }
      .google:hover{
         color: $google;
      }
      .facebook:hover{
         color: $facebook;
      }
      .twitter:hover{
         color: $twitter;
      }
   }
   .logo-box{
      margin: 100px 0 80px 0;
   }
   .form-box{
      padding: 40px 0 12px 0 !important;

      .col-12{
         padding: 0;
      }
   }
   .link-txt{
      text-align: right;
   }
   .login{
      padding: 10px 0;
      .h3{
         margin: 0 0 10px 0;
      }
   }
	.row {
		margin: 0 !important;
	}
	.form-row {
		margin: 15px 0 0 0;
	}
	.image-back {
		// background: url("/img/space.svg") no-repeat;
		// background: url("/img/mountain.svg") no-repeat;
		background: url("/img/back.png") no-repeat;
		height: 100vh;
		background-size: cover;
		background-position: center;
		position: relative;

      .copyright {
         position: absolute;
         bottom: 10px;
         right: 10px;
         color: $white;
         font-weight: $weight-bold;
      }
      .overlay{
         position: absolute;
         top: 0;
         bottom: 0;
         right: 0;
         left: 0;
         // background: rgba($primary-d,.5);
         // background: rgba(#000,.5);
      }
		.txt-box {
			position: absolute;
			bottom: 100px;
			left: 70px;
			width: 60%;

			.txt {
				color: var(--white);
				margin-left: 20px;
				border-left: solid 3px var(--white);
				padding: 10px 0 10px 20px;
				font-size: 15px;
			}
		}
	}
}
</style>